// extracted by mini-css-extract-plugin
export default {"noItems":"no-items_noItems__wFRHX"};